import React from 'react';

const SwiperSkeleton = props => <div className="w-full h-full bp3-skeleton" />;

export default SwiperSkeleton;